<section class="cr-hilfe">

  <!-- HERO -->
  <div class="cr-hilfe__hero">
    <div class="cr-hilfe__hero-inner">
      <a routerLink="/hilfe" class="cr-hilfe__back">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/>
        </svg>
        Zurück zur Rollenwahl
      </a>

      <span class="cr-hilfe__eyebrow">
        @if (audience() === 'kunden') { Hilfe für Kunden }
        @else { Hilfe für Handwerker }
      </span>
      <h1 class="cr-hilfe__title">
        @if (audience() === 'kunden') {
          Antworten zu Anfragen, Buchungen, Zahlungen.
        } @else {
          Antworten zu Onboarding, Provision, Aufträgen.
        }
      </h1>

      <div class="cr-hilfe__searchbox">
        <span class="cr-hilfe__search-icon" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/>
            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
        </span>
        <input
          type="search"
          class="cr-hilfe__search-input"
          [ngModel]="query()"
          (ngModelChange)="onQueryChange($event)"
          placeholder="Wonach suchst du?"
          aria-label="Hilfe-Artikel durchsuchen"
        />
      </div>

      @if (isSearching()) {
        <div class="cr-hilfe__results" role="listbox">
          @if (hits().length === 0) {
            <div class="cr-hilfe__results-empty">
              Nichts passendes gefunden?
              <a href="#kontakt">Schreib uns über das Kontaktformular ↓</a>
            </div>
          } @else {
            @for (hit of hits(); track hit.article.slug) {
              <a [href]="articleHref(hit.article.slug)" class="cr-hilfe__result"
                 role="option">
                <span class="cr-hilfe__result-q">{{ hit.article.question }}</span>
                <span class="cr-hilfe__result-summary">{{ hit.article.summary }}</span>
              </a>
            }
          }
        </div>
      }

      @if (audience() === 'kunden') {
        <div class="cr-hilfe__notfall-banner">
          <span class="cr-hilfe__notfall-icon" aria-hidden="true">⚡</span>
          <span class="cr-hilfe__notfall-text">
            <strong>Notfall?</strong>
            Rohrbruch, Stromausfall, Schlüsseldienst — wir vermitteln rund um die Uhr.
          </span>
          <a href="#cat-notfall" class="cr-hilfe__notfall-link">
            Mehr erfahren →
          </a>
        </div>
      }
    </div>
  </div>

  <!-- KATEGORIE-GRID -->
  <div class="cr-hilfe__container">
    <section class="cr-hilfe__cats">
      <h2 class="cr-hilfe__section-title">Themen</h2>
      <div class="cr-hilfe__cats-grid">
        @for (cat of categories(); track cat.id) {
          <button type="button" class="cr-hilfe__cat" (click)="scrollToCategory(cat.id)">
            <span class="cr-hilfe__cat-icon"><i class="pi {{ cat.icon }}"></i></span>
            <span class="cr-hilfe__cat-label">{{ cat.label }}</span>
            <span class="cr-hilfe__cat-count">
              {{ articlesByCategory()[cat.id]?.length ?? 0 }} Fragen
            </span>
          </button>
        }
      </div>
    </section>

    <!-- FAQ-SEKTIONEN -->
    @for (cat of categories(); track cat.id) {
      <section class="cr-hilfe__faq" [id]="'cat-' + cat.id">
        <header class="cr-hilfe__faq-head">
          <h2 class="cr-hilfe__faq-title">{{ cat.label }}</h2>
          @if (cat.description) {
            <p class="cr-hilfe__faq-desc">{{ cat.description }}</p>
          }
        </header>
        <div class="cr-hilfe__accordion">
          @for (a of articlesByCategory()[cat.id]; track a.slug) {
            <article class="cr-hilfe__item" [class.cr-hilfe__item--open]="openSlug() === a.slug">
              <button type="button"
                      class="cr-hilfe__item-q"
                      [attr.aria-expanded]="openSlug() === a.slug"
                      (click)="toggleArticle(a.slug)">
                <span>{{ a.question }}</span>
                <svg class="cr-hilfe__chevron" width="16" height="16" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                     stroke-linejoin="round">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>
              @if (openSlug() === a.slug) {
                <div class="cr-hilfe__item-body cr-prose" [innerHTML]="a.bodyHtml"></div>
                <div class="cr-hilfe__item-foot">
                  <a [href]="articleHref(a.slug)" class="cr-hilfe__item-link">
                    Direkt-Link zu dieser Frage →
                  </a>
                </div>
              }
            </article>
          }
        </div>
      </section>
    }

    <!-- KONTAKTFORMULAR -->
    <app-kontaktformular [audience]="contactAudience()"></app-kontaktformular>
  </div>
</section>
